export default "__VITE_ASSET__DsgEksg2__"